import { ServerEnvironment } from "./ServerEnvironment";
import { ServerEnvironmentResolver } from "./ServerEnvironmentResolver";

export const useResolveServerEnvironmentFromWindowLocation =
  (): ServerEnvironment => {
    return ServerEnvironmentResolver.resolveFromWindowLocation();
  };
